import Footer from 'components/footer/Footer';
import Form from 'components/form/Form';
import modulesMap from 'core/modulesMap';
import { extractInfoFromXhr } from 'navigation/page-manager/CustomPageManager';
import MainPage from 'navigation/pages/MainPage';
import NativeSelect from '../../components/native-select/NativeSelect';
export default class Contact extends MainPage {
    loading = false;
    getModulesMap() {
        return {
            adaptableWrapper: modulesMap.adaptableWrapper,
            footer: ['footer', Footer],
            form: ['.contact__form', Form],
            select: ['.native-select', NativeSelect]
        };
    }
    initialized() {
        super.initialized();
        this.modules.form.submitCallback = this.onFormSubmit;
    }
    onFormSubmit = (formData, urlParameters) => {
        const form = this.modules.form;
        const xhr = new XMLHttpRequest();
        this.loading = true;
        xhr.withCredentials = true;
        xhr.open(form.method, form.action, true);
        xhr.responseType = 'document';
        xhr.onload = this.onXhrComplete;
        xhr.send(formData);
        return false;
    };
    onXhrComplete = (event) => {
        const form = this.modules.form;
        form.submitted = false;
        this.loading = false;
        const xhr = event.currentTarget;
        extractInfoFromXhr(xhr);
        xhr.onload = null;
        this.modules.form.clear();
    };
    resize() {
        this.el.style.setProperty('--submit-wrapper-height', `${this.refs.submitWrapper.clientHeight}px`);
        this.el.style.setProperty('--contact-header-height', `${this.refs.header?.clientHeight}px`);
    }
}
